import _classCallCheck from "/Users/jinu/Downloads/stussy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jinu/Downloads/stussy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jinu/Downloads/stussy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jinu/Downloads/stussy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/jinu/Downloads/stussy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import PropTypes from "prop-types";
import { initialConfig } from "./config";
import { Typing as LibTyping } from "./LibTyping";

var Typing = /*#__PURE__*/function (_React$Component) {
  _inherits(Typing, _React$Component);

  // eslint-disable-next-line no-useless-constructor
  function Typing(props) {
    _classCallCheck(this, Typing);

    return _possibleConstructorReturn(this, _getPrototypeOf(Typing).call(this, props));
  }

  _createClass(Typing, [{
    key: "render",
    value: function render() {
      var text = this.props.text;
      return /*#__PURE__*/React.createElement(LibTyping, _extends({}, this.props, {
        key: text
      }));
    }
  }]);

  return Typing;
}(React.Component);

Typing.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  typeSpeed: PropTypes.number,
  suppressEmptyArray: PropTypes.bool,
  ignoreInitialDelay: PropTypes.bool,
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  styleClass: PropTypes.string,
  letterSpacing: PropTypes.number,
  cursorThickness: PropTypes.number,
  cursorColor: PropTypes.string,
  cursorPadding: PropTypes.number,
  deleteSpeed: PropTypes.number,
  shouldDelete: PropTypes.bool,
  blinkingSpeed: PropTypes.number,
  disableBlinkingOnEnd: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  smartBackspace: PropTypes.bool
};
Typing.defaultProps = {
  typeSpeed: initialConfig.typeSpeed,
  suppressEmptyArray: initialConfig.suppressEmptyArray,
  ignoreInitialDelay: initialConfig.ignoreInitialDelay,
  element: initialConfig.element,
  styleClass: initialConfig.styleClass,
  letterSpacing: initialConfig.letterSpacing,
  cursorThickness: initialConfig.cursorThickness,
  cursorColor: initialConfig.cursorColor,
  cursorPadding: initialConfig.cursorPadding,
  shouldDelete: initialConfig.shouldDelete,
  deleteSpeed: initialConfig.deleteSpeed,
  blinkingSpeed: initialConfig.blinkingSpeed,
  disableBlinkingOnEnd: initialConfig.disableBlinkingOnEnd,
  smartBackspace: initialConfig.smartBackspace
};
export { Typing };